import React, { useRef } from "react";
import poster1 from './Image/cv1.PNG';
import poster2 from './Image/cv2.PNG';
import poster3 from './Image/cv3.PNG';

const ContentComic = () => {
  const data = [
    {
      title: "THE HISTORY OF THE ROMAN EMPIRE",
      link: ["https://backend.whalesai.com/public/hiwvideos/1080-1080-comic-video.mp4"],
      level: '1:1 1080 X 1080 PX',
      poster: poster1,
    },
    {
      title: "THE WORLD OF INSECTS",
      link: ["https://backend.whalesai.com/public/hiwvideos/1920-1080-comic-video.mp4"],
      level: '16:9 1920 X 1080 PX',
      poster: poster2,
    },
    {
      title: "THE HISTORY OF THE INTERNET",
      link: ["https://backend.whalesai.com/public/hiwvideos/1080-1920-comic-video.mp4"],
      level: '9:16 1080 X 1920 PX',
      poster: poster3,
    },
  ];

  const videoRefs = useRef([]);

  const handlePlay = (index) => {
    videoRefs.current.forEach((video, i) => {
      if (i !== index && video) {
        video.pause();
      }
    });
  };

  return (
    <div className="text-white">
      <div>
        {data.map((video, index) => (
          <div key={index} className="text-center">
            <p>{video.title}</p>
            <p>{video.level}</p>
            {video.link.map((i, j) => (
              <div
                key={j}
                style={{ marginBlock: "20px" }}
                className="d-flex gap-2 flex-column justify-content-center align-items-center mx-auto"
              >
                <video
                  controls
                  playsInline
                  poster={video.poster}
                  src={i}
                  className="comic-video"
                  type="video/mp4"
                  ref={(el) => (videoRefs.current[index] = el)}
                  onPlay={() => handlePlay(index)}
                />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContentComic;
